export default __webpack_public_path__ + "static/media/835.ff2819e1.png";